import { baseApi } from './baseApi';
import {
  PurchaseOrder,
  CreatePurchaseOrderRequest,
  UpdatePurchaseOrderRequest,
  ReceivePurchaseOrderRequest,
  LowStockPurchaseOrderSuggestion,
} from '../types/inventory';

export const purchaseOrdersApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPurchaseOrders: builder.query<PurchaseOrder[], void>({
      query: () => '/purchaseorders',
      providesTags: ['PurchaseOrder'],
    }),
    getPurchaseOrder: builder.query<PurchaseOrder, string>({
      query: (id) => `/purchaseorders/${id}`,
      providesTags: (_result, _error, id) => [{ type: 'PurchaseOrder', id }],
    }),
    createPurchaseOrder: builder.mutation<PurchaseOrder, CreatePurchaseOrderRequest>({
      query: (data) => ({ url: '/purchaseorders', method: 'POST', body: data }),
      invalidatesTags: ['PurchaseOrder'],
    }),
    updatePurchaseOrder: builder.mutation<PurchaseOrder, { id: string; data: UpdatePurchaseOrderRequest }>({
      query: ({ id, data }) => ({ url: `/purchaseorders/${id}`, method: 'PUT', body: data }),
      invalidatesTags: ['PurchaseOrder'],
    }),
    deletePurchaseOrder: builder.mutation<void, string>({
      query: (id) => ({ url: `/purchaseorders/${id}`, method: 'DELETE' }),
      invalidatesTags: ['PurchaseOrder'],
    }),
    updatePurchaseOrderStatus: builder.mutation<PurchaseOrder, { id: string; status: string }>({
      query: ({ id, status }) => ({ url: `/purchaseorders/${id}/status`, method: 'PATCH', body: { status } }),
      invalidatesTags: ['PurchaseOrder'],
    }),
    receivePurchaseOrder: builder.mutation<PurchaseOrder, { id: string; data: ReceivePurchaseOrderRequest }>({
      query: ({ id, data }) => ({ url: `/purchaseorders/${id}/receive`, method: 'POST', body: data }),
      invalidatesTags: ['PurchaseOrder', 'InventoryItem', 'InventoryMovement'],
    }),
    getLowStockSuggestions: builder.query<LowStockPurchaseOrderSuggestion, void>({
      query: () => '/purchaseorders/low-stock-suggestions',
      keepUnusedDataFor: 0,
    }),
    getPurchaseOrderPdf: builder.query<Blob, string>({
      query: (id) => ({
        url: `/purchaseorders/${id}/pdf`,
        responseHandler: (response) => response.blob(),
      }),
    }),
  }),
});

export const {
  useGetPurchaseOrdersQuery,
  useGetPurchaseOrderQuery,
  useCreatePurchaseOrderMutation,
  useUpdatePurchaseOrderMutation,
  useDeletePurchaseOrderMutation,
  useUpdatePurchaseOrderStatusMutation,
  useReceivePurchaseOrderMutation,
  useLazyGetLowStockSuggestionsQuery,
  useLazyGetPurchaseOrderPdfQuery,
} = purchaseOrdersApi;
